/*
 * Load the Breeze checkout SDK only when a shopper shows cart/checkout intent.
 * Product and cart templates keep the vendor's original eager tags in
 * layout/theme.liquid; this file runs on lighter browsing pages.
 */
(function () {
  var loader = document.getElementById('WearoBreezeLoader');
  if (!loader || window.WearoBreeze) return;

  var configSrc = loader.dataset.configSrc;
  var moduleSrc = loader.dataset.moduleSrc;
  var loadPromise;
  var replayingCheckout = false;

  function appendScript(src) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.async = false;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function waitUntilReady() {
    return new Promise(function (resolve) {
      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts += 1;
        if (
          !window.customElements ||
          window.customElements.get('breeze-button') ||
          attempts >= 50
        ) {
          window.clearInterval(timer);
          resolve();
        }
      }, 50);
    });
  }

  function load() {
    if (!loadPromise) {
      loadPromise = appendScript(configSrc).then(function () {
        return appendScript(moduleSrc);
      }).then(function () {
        return waitUntilReady();
      });
    }

    return loadPromise;
  }

  window.WearoBreeze = { load: load };

  var intentSelector = [
    '#cart-icon-bubble',
    '.header__icon--cart',
    'a[href*="/cart"]',
    'a[href*="/checkout"]',
    'form[action*="/cart/add"]',
    'product-form',
    '[name="checkout"]',
    '.shopifycheckoutbtn'
  ].join(',');

  function hasIntent(event) {
    return event.target.closest && event.target.closest(intentSelector);
  }

  ['pointerover', 'focusin', 'touchstart'].forEach(function (eventName) {
    document.addEventListener(
      eventName,
      function (event) {
        if (hasIntent(event)) load().catch(function () {});
      },
      { capture: true, passive: true }
    );
  });

  document.addEventListener(
    'submit',
    function (event) {
      if (event.target.matches && event.target.matches('form[action*="/cart/add"]')) {
        load().catch(function () {});
      }
    },
    true
  );

  /*
   * A persisted cart can expose Checkout before any add-to-cart interaction.
   * Hold that first click, let Breeze attach its handlers, then replay it. If
   * the vendor request fails, replaying still falls back to native Shopify
   * checkout, so the shopper is never trapped.
   */
  document.addEventListener(
    'click',
    function (event) {
      if (replayingCheckout || !event.target.closest) return;

      var checkout = event.target.closest(
        '[name="checkout"], .shopifycheckoutbtn, a[href*="/checkout"]'
      );

      if (!checkout) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      checkout.setAttribute('aria-busy', 'true');

      load()
        .catch(function () {})
        .then(function () {
          checkout.removeAttribute('aria-busy');
          replayingCheckout = true;
          checkout.click();
          replayingCheckout = false;
        });
    },
    true
  );
})();
